<card>
    <air-search-header class="card-header-content"
                       [canUseAirSearchForm]="canUseAirSearchForm"
                       [hasAirSearchRequest]="hasAirSearchRequest"
                       [isAirSearchFormVisible]="isAirSearchFormVisible"
                       [airSearchContext]="airSearchContext"></air-search-header>
    <div class="card-body-content card-marge-inside">
        <ng-container *ngIf="!isLoad else loader">
            <air-search-resume *ngIf="airSearchRequest && !isAirSearchFormVisible"
                               [airSearchRequest]="airSearchRequest"></air-search-resume>
            <air-search-form [style.display]="isAirSearchFormVisible ? 'block' : 'none'"
                             [airSearchFormValues]="airSearchFormValues"
                             [airSearchContext]="airSearchContext"
                             [wayType]="wayType"
                             (onSearch)="onSearch($event)"></air-search-form>
        </ng-container>
        <ng-template #loader>
            <loader [message]="wording.loader"></loader>
        </ng-template>
    </div>
</card>
